/**
 * Flow Event Emitter
 * Centralizes emitting lifecycle events both to the host (via postMessage)
 * and internally (for analytics, logging, etc.).
 */

import type { FlowType } from "@/types/session.types";
import { sendMessageToHost } from "@utils/messaging";

export function emitFlowStarted(flow: FlowType, sessionId: string): void {
  sendMessageToHost({
    type: "FLOW_STARTED",
    payload: { flow, sessionId }
  });
}

export function emitFlowCompleted(
  flow: FlowType,
  sessionId: string,
  result?: Record<string, unknown>
): void {
  sendMessageToHost({
    type: "FLOW_COMPLETED",
    payload: { flow, sessionId, result }
  });
}

export function emitFlowExpired(flow: FlowType, sessionId: string): void {
  sendMessageToHost({
    type: "FLOW_EXPIRED",
    payload: { flow, sessionId }
  });
}

export function emitFlowExited(
  flow: FlowType,
  sessionId: string,
  reason: "user_cancelled" | "navigation" | "error"
): void {
  sendMessageToHost({
    type: "FLOW_EXITED",
    payload: { flow, sessionId, reason }
  });
}

export function emitFlowError(
  error: string,
  flow?: FlowType,
  sessionId?: string
): void {
  sendMessageToHost({
    type: "FLOW_ERROR",
    payload: { flow, sessionId, error }
  });
}
